module["exports"] = [
  "Bay",
  "Bayan",
  "Dr.",
  "Prof. Dr."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/name/prefix.js
// module id = 1759
// module chunks = 0